import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute z-[250] flex h-screen w-screen items-center justify-center justify-items-center align-middle"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-screen w-screen bg-slate-500 opacity-40" }, null, -1)
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass(`text-white`)
}
const _hoisted_4 = {
  key: 0,
  class: "company"
}
const _hoisted_5 = { class: "sidebar-scroll overflow-y-auto" }
const _hoisted_6 = { class: "last:pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_parking_space_selector_modal = _resolveComponent("parking-space-selector-modal")!
  const _component_paginated_company_dropdown = _resolveComponent("paginated-company-dropdown")!
  const _component_tree_list = _resolveComponent("tree-list")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_Loader, { class: "opacity-100" })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(`absolute ${
      _ctx.sidebarStore.isSidebarOpened ? 'left-[258px]' : 'left-[50px]'
    }  top-1/2 z-[250] transform duration-300 ease-in-out`)
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: ['fas', 'grip-lines-vertical'],
        class: "cursor-col-resize text-base text-darkgrey",
        onClick: _ctx.sidebarStore.toggleSidebar
      }, null, 8, ["onClick"])
    ], 2),
    (_ctx.isParkingSpaceSelectorModalOpened)
      ? (_openBlock(), _createBlock(_component_parking_space_selector_modal, {
          key: 1,
          "is-selector-modal-opened": _ctx.isParkingSpaceSelectorModalOpened,
          onToggleModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isParkingSpaceSelectorModalOpened = false))
        }, null, 8, ["is-selector-modal-opened"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(`sidebar transform duration-300 ease-in-out  ${
      _ctx.sidebarStore.isSidebarOpened ? 'w-64' : 'w-12'
    }  bottom-0 left-0 flex flex-col bg-sidebarcolor px-2 py-4 ${
      _ctx.config.IS_PARKOM == 'true' ? 'pb-16' : 'pb-4'
    } `)
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(`flex pb-1 ${
          _ctx.sidebarStore.isSidebarOpened ? 'justify-end' : 'justify-center'
        }`)
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: 
            _ctx.sidebarStore.isSidebarOpened
              ? ['fas', 'angles-left']
              : ['fas', 'angles-right']
          ,
            class: "cursor-pointer text-base text-white",
            onClick: _ctx.sidebarStore.toggleSidebar
          }, null, 8, ["icon", "onClick"])
        ], 2),
        (_ctx.sidebarStore.isSidebarOpened)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_paginated_company_dropdown, { onUpdateActiveCompany: _ctx.updateActiveCompany }, null, 8, ["onUpdateActiveCompany"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(`flex flex-col gap-4 ${_ctx.routes.length >= 2 ? 'divide-y-2' : ''}`)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (group) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (route) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: route.name
                }, [
                  (
                !route.meta?.authorize ||
                _ctx.permissionStore.hasPermissionView(route.meta?.authorize)
              )
                    ? (_openBlock(), _createBlock(_component_tree_list, {
                        key: 0,
                        route: route
                      }, null, 8, ["route"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          }), 256))
        ], 2)
      ]),
      (_ctx.config.IS_PARKOM == 'true')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(`absolute bottom-3 flex items-center ${
        _ctx.sidebarStore.isSidebarOpened
          ? 'left-52 justify-end'
          : 'left-0 justify-center'
      }`)
          }, [
            _withDirectives(_createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'folder-tree'],
              class: "cursor-pointer p-3 text-lg text-white hover:bg-darker",
              onClick: _cache[1] || (_cache[1] = () => _ctx.toggleAction('treeView'))
            }, null, 512), [
              [_directive_tippy, _ctx.$t('SidebarMenu.SelectParkingSpaces')]
            ])
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}